import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-responsive-modal';
import store from '../../../storeClient';
import ConsultasClient from '../../api/consultas';
import { useColors } from 'frontend/hooks/useColors';

export default function ConsultaAgenciaModal({ agency, onClose }) {
  const { t } = useTranslation();
  const { background, text } = useColors();
  const { token, nombre: nombreAgencia } = store.getState().applicationState;
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [consulta, setConsulta] = useState('');

  const resetForm = () => {
    setNombre('');
    setApellido('');
    setEmail('');
    setTelefono('');
    setConsulta('');
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const enviarConsulta = useCallback(
    async (e) => {
      e.preventDefault();
      let data = {
        nombre,
        apellido,
        email,
        telefono,
        consulta,
        nombreAgencia,
        tipoConsulta: 'oficina',
        emailAgencia: agency.email,
      };

      const response = await ConsultasClient.enviarMailContacto(data, token);

      if (response.status === 200 || response.status === 201) {
        resetForm();
        alert('Consulta enviada exitosamente');
        handleClose();
      } else {
        alert('Error al enviar la consulta');
      }
    },
    [nombre, email, telefono, consulta],
  );

  const handleNombreChange = (event) => {
    setNombre(event.target.value);
  };

  const handleApellidoChange = (event) => {
    setApellido(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleTelefonoChange = (event) => {
    const value = event.target.value;
    if (value.length <= 20) {
      setTelefono(value);
    }
  };

  const handleConsultaChange = (event) => {
    setConsulta(event.target.value);
  };

  return (
    !!agency && (
      <Modal
        classNames={{ modal: 'package-modal consulta-agency-modal' }}
        open
        onClose={handleClose}
      >
        <div className="flex flex-col md:flex-row gap-8">
          <div className="flex flex-col w-full">
            <div className="modal-package-search__header">
              <i
                className="fa fa-paper-plane package-search__icon text-footer-default"
                style={{ color: background }}
              />
              <div className="package-search__form__title">Enviá tu consulta</div>
            </div>
            <div className="hidden md:block my-2 text-2xl text-gray-600">{agency.nombre}</div>
            <form className="form-inline consulta-modal__content" onSubmit={enviarConsulta}>
              <div className="form-group">
                <div className="clearfix" />
                <span className="block text-gray-700 text-sm font-bold mb-2">
                  {t('requestForm.name')} (*)
                </span>
                <input
                  id="nombre"
                  onChange={handleNombreChange}
                  value={nombre}
                  name="nombre"
                  type="text"
                  maxLength={50}
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                  required
                />
              </div>
              <div className="form-group">
                <div className="clearfix" />
                <span className="block text-gray-700 text-sm font-bold mb-2">
                  {t('requestForm.lastName')} (*)
                </span>
                <input
                  id="apellido"
                  onChange={handleApellidoChange}
                  value={apellido}
                  name="apellido"
                  type="text"
                  maxLength={50}
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full ma-2"
                  required
                />
              </div>
              <div className="form-group">
                <span className="block text-gray-700 text-sm font-bold mb-2">E-mail (*)</span>
                <input
                  id="email"
                  onChange={handleEmailChange}
                  value={email}
                  name="email"
                  type="email"
                  maxLength={50}
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                  required
                />
              </div>
              <div className="form-group">
                <span className="block text-gray-700 text-sm font-bold mb-2">
                  {t('requestForm.phone')}
                </span>
                <input
                  id="telefono"
                  onChange={handleTelefonoChange}
                  value={telefono}
                  name="telefono"
                  type="number"
                  maxLength={20}
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                />
              </div>
              <div className="form-group">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="comentarios">
                  {t('requestForm.message')} (*)
                </label>
                <textarea
                  id="comentarios"
                  onChange={handleConsultaChange}
                  value={consulta}
                  name="comentarios"
                  className="h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                  rows="5"
                  placeholder={t('requestForm.commentsPlaceholder')}
                  required
                />
              </div>
              <div className="package-search__button-row">
                <button
                  className="package-search__button big-package-search__button"
                  style={{
                    backgroundColor: background,
                    color: text,
                  }}
                >
                  <i className="fa fa-paper-plane heading__icon" />
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    )
  );
}
